/**
 * @generated SignedSource<<16465d592b830af7df0be8dd588953cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobSortField = "CREATE_DATE" | "JOB_LABEL" | "JOB_TITLE" | "JOB_TITLE_ID" | "MODIFIED" | "OWNER_FIRST_NAME" | "OWNER_LAST_NAME" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JobFiltersInput = {
  clientIdIn?: ReadonlyArray<string | null> | null;
  clientidIn?: ReadonlyArray<number | null> | null;
  createdById?: ReadonlyArray<string | null> | null;
  exclude?: ReadonlyArray<string | null> | null;
  fromDate?: string | null;
  jobLabelIContains?: string | null;
  jobLabelIExact?: string | null;
  jobTitleIContains?: string | null;
  jobTitleId?: string | null;
  only?: ReadonlyArray<string | null> | null;
  ownerId?: ReadonlyArray<string | null> | null;
  tagIdIn?: ReadonlyArray<string | null> | null;
  tagnameIn?: ReadonlyArray<string | null> | null;
  toDate?: string | null;
};
export type JobSortInput = {
  caseSensitive?: boolean | null;
  direction?: SortDirection | null;
  field: JobSortField;
};
export type AdminClientJobsRefetchQuery$variables = {
  after?: string | null;
  before?: string | null;
  filters?: JobFiltersInput | null;
  first?: number | null;
  last?: number | null;
  order: ReadonlyArray<JobSortInput | null>;
};
export type AdminClientJobsRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminClientJobs_viewer">;
  } | null;
};
export type AdminClientJobsRefetchQuery = {
  response: AdminClientJobsRefetchQuery$data;
  variables: AdminClientJobsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v6 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v7 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v8 = {
  "kind": "Variable",
  "name": "filters",
  "variableName": "filters"
},
v9 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v10 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v11 = {
  "kind": "Variable",
  "name": "order",
  "variableName": "order"
},
v12 = {
  "kind": "Literal",
  "name": "section",
  "value": "ADMIN"
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userId",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientId",
  "storageKey": null
},
v22 = {
  "kind": "Literal",
  "name": "filters",
  "value": {}
},
v23 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v24 = {
  "kind": "Literal",
  "name": "order",
  "value": [
    {
      "direction": "ASC",
      "field": "NAME"
    }
  ]
},
v25 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/),
  (v12/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v29 = [
  "filters"
],
v30 = [
  (v22/*: any*/),
  (v23/*: any*/),
  (v24/*: any*/)
],
v31 = [
  (v22/*: any*/),
  (v23/*: any*/),
  {
    "kind": "Literal",
    "name": "order",
    "value": [
      {
        "direction": "ASC",
        "field": "USERNAME"
      }
    ]
  },
  (v12/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminClientJobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "AdminClientJobs_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminClientJobsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "concreteType": "JobNodeTypeConnection",
            "kind": "LinkedField",
            "name": "jobs",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPreviousPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startCursor",
                    "storageKey": null
                  },
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "JobNodeTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "JobNodeType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "jobDescription",
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegacyUserNode",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagNode",
                        "kind": "LinkedField",
                        "name": "tags",
                        "plural": true,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "tagId",
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LegacyUserNode",
                            "kind": "LinkedField",
                            "name": "owner",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/),
                              (v18/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ClientNode",
                                "kind": "LinkedField",
                                "name": "client",
                                "plural": false,
                                "selections": [
                                  (v21/*: any*/),
                                  (v19/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "TagNodeConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TagNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TagNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v19/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": "tags(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"NAME\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "filters": (v29/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortTags_tags",
            "kind": "LinkedHandle",
            "name": "tags"
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "concreteType": "ClientTypeNodeConnection",
            "kind": "LinkedField",
            "name": "allClients",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              (v15/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v21/*: any*/),
                      (v19/*: any*/),
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "allClients(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"NAME\"}])"
          },
          {
            "alias": null,
            "args": (v30/*: any*/),
            "filters": (v29/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortClients_allClients",
            "kind": "LinkedHandle",
            "name": "allClients"
          },
          {
            "alias": null,
            "args": (v31/*: any*/),
            "concreteType": "AuthorNodeConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AuthorNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AuthorNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v20/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "firstName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastName",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "email",
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              },
              (v28/*: any*/)
            ],
            "storageKey": "authors(filters:{},first:10,order:[{\"direction\":\"ASC\",\"field\":\"USERNAME\"}],section:\"ADMIN\")"
          },
          {
            "alias": null,
            "args": (v31/*: any*/),
            "filters": (v29/*: any*/),
            "handle": "connection",
            "key": "FilterAndSortCreatedBy_authors",
            "kind": "LinkedHandle",
            "name": "authors"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23ad26d8bb9ca152092660d5da5fdf7e",
    "id": null,
    "metadata": {},
    "name": "AdminClientJobsRefetchQuery",
    "operationKind": "query",
    "text": "query AdminClientJobsRefetchQuery(\n  $first: Int\n  $last: Int\n  $after: String\n  $before: String\n  $filters: JobFiltersInput\n  $order: [JobSortInput]!\n) {\n  viewer {\n    ...AdminClientJobs_viewer_4rXfl6\n  }\n}\n\nfragment AdminClientJobs_viewer_4rXfl6 on Viewer {\n  jobs(first: $first, last: $last, after: $after, before: $before, filters: $filters, order: $order, section: ADMIN) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        jobId\n        ...Job_job\n      }\n    }\n  }\n  ...FilterAndSortTags_viewer\n  ...FilterAndSortClients_viewer\n  ...FilterAndSortCreatedBy2_viewer\n}\n\nfragment FilterAndSortClients_viewer on Viewer {\n  allClients(first: 10, filters: {}, order: [{direction: ASC, field: NAME}]) {\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    totalCount\n    edges {\n      node {\n        id\n        clientId\n        name\n        __typename\n      }\n      cursor\n    }\n  }\n}\n\nfragment FilterAndSortCreatedBy2_viewer on Viewer {\n  authors(first: 10, filters: {}, order: [{direction: ASC, field: USERNAME}], section: ADMIN) {\n    edges {\n      node {\n        id\n        userId\n        firstName\n        lastName\n        username\n        email\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment FilterAndSortTags_viewer on Viewer {\n  tags(first: 10, filters: {}, order: [{direction: ASC, field: NAME}], section: ADMIN) {\n    edges {\n      node {\n        id\n        name\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment Job_job on JobNodeType {\n  id\n  jobId\n  jobTitle\n  jobLabel\n  jobDescription\n  created\n  createdBy {\n    username\n  }\n  tags {\n    id\n    ...Tag_tag\n  }\n}\n\nfragment Tag_tag on TagNode {\n  id\n  tagId\n  name\n  created\n  owner {\n    userId\n    username\n    client {\n      clientId\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "082cdfafd9621ee1ab31c3391c100e19";

export default node;
